import { render, staticRenderFns } from "./TnCModal.vue?vue&type=template&id=a8cb3452&"
import script from "./TnCModal.vue?vue&type=script&lang=js&"
export * from "./TnCModal.vue?vue&type=script&lang=js&"
import style0 from "./TnCModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports